export default "__VITE_ASSET__B$DrRgKK__"